"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const NavigationChevronRight_1 = __importDefault(require("../Icon/Icons/components/NavigationChevronRight"));
const BreadcrumbsConstants_1 = require("./BreadcrumbsConstants");
require("./BreadcrumbsBar.scss");
const BreadcrumbsBar = ({ className, children, type = BreadcrumbsConstants_1.BreadcrumbsBarType.INDICATION }) => ((0, jsx_runtime_1.jsx)("nav", Object.assign({ "aria-label": "Breadcrumb", className: (0, classnames_1.default)("breadcrumbs-bar--wrapper", className) }, { children: (0, jsx_runtime_1.jsx)("ol", { children: children &&
            react_1.default.Children.map(children, (child, index) => react_1.default.isValidElement(child)
                ? [
                    index > 0 && (0, jsx_runtime_1.jsx)(NavigationChevronRight_1.default, { className: "sparatorIcon", size: "14", "aria-hidden": "true" }),
                    react_1.default.cloneElement(child, Object.assign(Object.assign({}, child === null || child === void 0 ? void 0 : child.props), { isClickable: type !== BreadcrumbsConstants_1.BreadcrumbsBarType.INDICATION }))
                ]
                : null) }) })));
Object.assign(BreadcrumbsBar, {
    types: BreadcrumbsConstants_1.BreadcrumbsBarType
});
exports.default = BreadcrumbsBar;
